<script>
export default {
    name: "EditRole",

    props: {
        role: Object,
        showModal: Boolean,
    },

    methods: {

        updateRole () {
            this.$root.loading = true;
            this.$http.post(`Admin/ManageRoles`, this.role).then(response => {
                this.$root.loading = false;
                this.$emit('closeModal');
                window.Swal.fire({ type: 'success', title: response.data });
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/2 w-2/3">
      <template v-slot:title>
        <h5 class="font-medium text-sm">Edit Role</h5>
      </template>
      <template v-slot:modal-body>
        <div class="flex flex-wrap -m-3">
            <div class="md:w-1/4 w-1/2 p-tiny">
                <label for="grid-name" class="label-control">Role:</label>
                <input type="text" v-model="role.role1" id="grid-name" class="input-control input-sm text-xs">
            </div>
            <div class="w-1/2 p-tiny">
                <label for="grid-description" class="label-control">Description:</label>
                <textarea v-model="role.description" id="grid-description" class="input-control text-xs" cols="3" rows="1"></textarea>
            </div>
            <div class="w-1/12 p-tiny mt-4">
                <label for="grid-status" class="label-control">Active
                    <input type="checkbox" v-model="role.active" id="grid-status"></label>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded mr-4" @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs rounded" @click.prevent="updateRole"><i class="fa fa-save"></i> Update</button>
      </template>
    </tail-modal>
</template>
